import { getApi, getApiExcel, postApi } from 'apis';

const downloadCsvTemplate = async () => {
	return await getApiExcel('/opening-balance/template-download');
};

const validateOpeningBalance = async (data: any) => {
	return await postApi(`/opening-balance/upload-csv`, data, true);
};

const importOpeningBalanceCsv = async (data: any) => {
	return await postApi(`/opening-balance/import`, data, true);
};

const fetchOpeningBalanceByEmployeeId = async (employeeId: any) => {
	return await getApi(`/opening-balance/${employeeId}`);
};

export const openingBalanceApi = {
	downloadCsvTemplate,
	importOpeningBalanceCsv,
	validateOpeningBalance,
	fetchOpeningBalanceByEmployeeId,
};
